import React, { useMemo } from "react";
import { CartCollection } from "./CartCollection";
import { useShopifyCart } from "@app/scripts/react-hooks/shopify";
import { Button } from "@app/scripts/react-general-components/Button";

type Props = Pick<
  ReturnType<typeof useShopifyCart>,
  "goToCheckout" | "giftsInCart" | "overGiftThreshold" | "gifts" | "giftIds"
> & {
  isOpen: boolean;
  giftPopupHeading?: string;
  setIsOpen: (val: boolean) => void;
};

export const CartGiftPopup: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  giftIds,
  giftsInCart,
  overGiftThreshold,
  goToCheckout,
  gifts,
  giftPopupHeading = "Don't forget to add your free gift!",
}) => {
  const requiresSelection = gifts?.length > 1 || gifts?.some((gift) => gift.variants?.length ?? 0 > 1);
  const shouldDisplay = giftsInCart.length === 0 && requiresSelection && overGiftThreshold;

  const closePopup = () => {
    setIsOpen(false);
    sessionStorage.setItem("giftPopupClosed", "true");
  };

  const visibleGiftIds = useMemo(() => gifts?.filter(g => !g?.hide_in_carousel)?.map(p => p.id), [gifts])

  return shouldDisplay && isOpen ? (
    <div className="geolocation__popup-wrap text-brand-dark-grey">
      <div className="geolocation__popup">
        <div className="geolocation__popup-inner" style={{ overflow: "hidden" }}>
          <h2 className="h1 bold">{giftPopupHeading}</h2>
          <div className="text-left smaller-md-items smaller-lg-items w-full">
            <CartCollection
              productIds={visibleGiftIds}
              disabledDesktop={false}
              disabledMobile={false}
              columnsDesktop={2}
              columnsMobile={1}
              hasQuickAddDrawer={false}
              active
              addToCartBtns
              addAsGift
            />
          </div>
          <Button onClick={closePopup} label={"Close"} variant="text" />
          <Button onClick={goToCheckout} label="Checkout" className="fullwidth" />
        </div>
      </div>
    </div>
  ) : null;
};
